import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addSequrityQuestion,
  deleteSequrityQuestion,
  getSequrityQuestion,
  updateSequrityQuestion,
} from "store/services/securityQuestions";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

// For Fetch All Sequrity Question
export const GetAllSequrityQuestionAction = createAsyncThunk(
  "security/getSequrityQuestion",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getSequrityQuestion(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// For Add Sequrity Question
export const AddSequrityQuestionAction = createAsyncThunk(
  "security/addSequrityQuestion",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await addSequrityQuestion(rest);
      if (res.status === 1) {
        dispatch(closeAdminModal());
        const responce = await getSequrityQuestion(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

// For Update Sequrity Question
export const UpdateSequrityQuestionAction = createAsyncThunk(
  "security/updateSequrityQuestion",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await updateSequrityQuestion(payload);
      if (res.status === 1) {
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

// For Delete Sequrity Question
export const DeleteSequrityQuestionAction = createAsyncThunk(
  "security/deleteSequrityQuestion",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteSequrityQuestion(rest);
      if (res.status === 1) {
        dispatch(closeAdminModal());
        const responce = await getSequrityQuestion(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
